// Type definitions for session and authentication data
import { Roles } from '@/utils/enums';

// Data structure for refresh token response
export interface RefreshTokenData {
  id_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

// Data structure for auth token response (includes access token)
export interface AuthTokenData extends RefreshTokenData {
  access_token: string;
}

// User permission object: role and allowed permissions
export interface UserPermission {
  role: string;
  permission: string[];
}

// User roles for a given environment
export interface UserRoles {
  env: string;
  roles: UserPermission[];
}

// User access profile for an application
export interface UserAccess {
  application: string;
  access: UserRoles[];
}

// Validation object for user session
export interface UserValidation {
  roles: UserAccess;
  allowUser: boolean;
}

// Payload for common service API requests
export interface CommonServicePayload {
  token: string;
  app: string;
  resource: string;
  stage: string;
}

// List of roles with priority for access control
export const rolelist = [
  { role: Roles.GLOBAL, priority: 1 },
  { role: Roles.USER, priority: 3 },
];

// Basic user info structure
export interface User {
  email: string;
  givenName: string;
  familyName: string;
  plants?: string[];
}

// Session state shape for Redux store
export interface SessionState {
  user: User | null;
  loading: boolean;
  isAuthorized: boolean;
  isAppInitialized: boolean;
  role: Roles;
  siteCode: string | null;
  responseErrorStatus: number;
}

// Decoded ID token structure from JWT
export interface DecodedIdToken {
  email: string;
  given_name: string;
  family_name: string;
  [key: string]: unknown;
}
